<!--2022 樱花专题-->
<template>
<div class="spring">
    <div class="top-head">
        <div class="warrp">
            <a target="_blank" href="//yorkbbs.ca" class="logo">YorkBBS.CA</a>
            <div class="flex-cont"></div>
            <div class="nav">
                <a target="_blank" href="//yorkbbs.ca">网站首页</a>
                <a target="_blank" href="//news.yorkbbs.ca">新闻</a>
                <a target="_blank" href="//forum.yorkbbs.ca">论坛</a>
            </div>
        </div>
    </div>
    <div class="banner" ref="banner">
        <div class="pc-banenr" :style="{'background-image':'url('+require('./assets/pc-banner-bg.png')+')'}">
            
            <img :src="require('./assets/pc-banner.png')" class="" alt="">
        </div>
        <div class="media-banner "><img :src="require('./assets/m-banner.png')" alt=""></div>
    </div>

    <!--顶部 专题引言-->
    <div class="introduction">
        <div class="top-quotes"><img :src="require('./assets/top-quotes.png')" alt=""></div>
        <div class="flex-cont ">
            准备好了吗？最美的花季即将来袭，共赴一场浪漫的花海约会！一起在多伦多，与春天的花海撞个满怀吧~
            <img :src="require('./assets/down-quotes.png')" alt="">
        </div>
    </div>
    <!--类型选择-->
    <div class="tab-style">
        <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
        <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
        <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
    </div>

    <!---列表展示-->
    <div class="post-list">
        <ItemSubject v-for="item in list" :key="item.id" :data="item" />
    </div>


    <!--操作按钮-->
    <div class="join-play">
        <div class="box">
            <a :href="'/publish/photography?subject=073b7bd4-a276-4f96-a44b-85af2a73fc2b'|hostBuild('forum')" target="_blank"><i class="el-icon-camera-solid"></i> 上传照片晒春天</a>
        </div>

    </div>
    

    <FooterWhite></FooterWhite> 
    <div style="height:100px"></div>

    <div class="play-detail"><a :href="'/detail/645e8ec3-882b-455f-bf90-318317ce2302?topic=manage'|hostBuild('forum')" target="_blank"><img width="70" :src="require('./assets/prize.png')" alt=""></a></div>

    <LeftShare style="left:50%" topic="073b7bd4-a276-4f96-a44b-85af2a73fc2b" v-show="showFunc" />
</div>
</template>
<script>
import { throttle } from 'throttle-debounce';
import FooterWhite from '@/components/footer-white.vue'
import ItemSubject from './item-subject.vue'
import LeftShare from '@/components/left-share.vue'
import { isScrollToPageBottom, inflowAdvConvert } from '@/utils/utils';
export default {
    name:'Spring2022',
    components:{FooterWhite,ItemSubject,LeftShare},
    data(){
        return  {
            type:0,
            listLoading:false,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_commentedAt: DESC'],
                "subject": [
                    "073b7bd4-a276-4f96-a44b-85af2a73fc2b"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            showFunc:false,//显示功能区
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        shareFun(){
            if( window.navigator.canShare && window.navigator.canShare({url:window.location.origin})){
                navigator.share({
                    title:'这个是title',
                    text:'这个是text字段，看有什么用',
                    url:window.location.origin,
                //text:'这个是text字段，看有什么用'
                })
                .then((res) => {
                console.log(res)
                })
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            }
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                this.list = this.list.concat(result.data.items);
                this.hasMore = result.data.items.length == this.params.size;
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/css/tax.css';
.spring{
    background-color: #f8f8f8;
}
@media screen and (min-width:768px) {
    .spring{
        
        background-image:url('./assets/pendant-l.png'),url('./assets/pendant-r.png');
        background-position: left 660px, right 760px;
        background-repeat: repeat-y, repeat-y;
    }
}

.top-head{
    position: absolute; left: 0; top: 0; right: 0; background: rgba(0,0,0,0.10);
    .warrp{
        display: flex; align-items: center; padding: 0 15px; height: 40px;
        .logo{font-size: 16px; line-height: 40px; color: #fff; font-weight: bold;}
        .flex-cont{flex:1;}
        .nav{
            display: flex; align-items: center;
            a{
                font-size: 14px; line-height: 20px; color: #fff; text-decoration: none;margin-left:20px;
                &:hover{text-decoration: underline;}
            }
        }
    }
}
.pc-banenr{display: none;}
.media-banner {display: block;}
@media screen and (min-width:768px){
    .top-head{
        .warrp{max-width: 1170px; margin:0 auto;}
    } 
    .pc-banenr{display: block; background-position:center top ;
        img{display: block; margin:0 auto}
    }
    .media-banner {display: none;}
}


/**开始引言部分 */
.introduction{
    margin: 0 15px 0; background: #fff; border-radius: 10px; transform: translateY(-50%); padding: 15px 10px;display: flex;
     img{width: 10px;}
   .top-quotes{margin:5px 5px 0 0;
       
    }
    .flex-cont{
        flex:1; overflow: hidden; font-size: 13px; line-height: 22px;
        img{display: inline-block; margin-top: -10px; margin-left: 10px;}
    }
}
@media screen and (min-width:768px){
    .introduction{
        padding: 30px; margin: -30px auto 0; max-width: 800px;border-radius: 20px;
         img{width: 20px;}
        .top-quotes{margin-right: 10px;
           
        }
        .flex-cont{
            flex:1; overflow: hidden; font-size: 18px; line-height: 30px;
            img{display: inline-block; margin-top: -10px; margin-left: 10px;}
        }
    }
}

.radius20{border-radius: 20px;}



.tab-style{
    display: flex; align-items: center; justify-content: center; margin-bottom: 15px !important; z-index: 10; margin-top: -20px;
    .item{
        font-size: 14px; line-height: 24px; margin-right: 40px; color: #666; user-select: none; cursor: pointer;
        &:last-child{margin-right: 0;}
        &.active{
            position: relative; font-weight: bold; z-index: 10; font-size: 18px; color: #111;
            &:after{
                position: absolute; content: ''; z-index: -1; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
            }
        }
    }

}
@media screen and (min-width:768px){
    .tab-style{
        display: flex; align-items: center; justify-content: center; margin-bottom: 30px !important;
        .item{
            font-size: 18px; line-height: 37px; margin-right: 40px; user-select: none; cursor: pointer;
            &:last-child{margin-right: 0;}
            &.active{
                position: relative; font-weight: bold; font-size: 26px;
                &:after{
                    position: absolute; content: ''; left: 0; bottom: 0; right: 0; height: 7px; background: #fa4a83;
                }
            }
        }

    }
}

.post-list{
    margin: 0 15px;overflow: hidden;
}
@media screen and (min-width:768px) {
    .post-list{

        max-width: 800px; margin: 0 auto; padding: 0 15px;
    }
}
@media screen and (min-width:992px){
    .post-list{padding: 0;}
}


/**参加活动按钮 */
.join-play{
    position: fixed; z-index: 100; left: 15px; right: 15px; bottom: 25px;
    .box{
        display: flex; align-items: center; background: linear-gradient(123deg,#ff6496 6%, #fa4a83 21%, #fa4a83 66%); height: 40px; font-size: 16px; line-height: 24px; justify-content: center; color: #fff; border-radius: 20px; user-select: none; cursor: pointer;
        a{flex:1; display: flex; align-items: center; justify-content: center; height: 40px;}
        i{font-size: 20px; margin-right:5px;}
    }
}
@media screen and (min-width:768px){
    .join-play{
        .box{max-width: 800px; margin: 0 auto; height: 50px; font-size: 20px; border-radius: 25px;
            a{height: 50px;}
            i{font-size: 26px;}
        }
    }
}


/**活动详情 */
@media screen and (max-width:768px){
    .play-detail{
        position: fixed; z-index: 50; bottom: 150px; right: 25px;
        img{width: 45px; height: 45px;}
    }
}

@media screen and (min-width:768px){
    .play-detail{
        position: fixed; z-index: 50; bottom: 200px; left:50%; margin-left: 480px;
        
    }
}
</style>